import { ChartDatum, DataWithArrays } from "./types";

export function toChartData<T extends DataWithArrays>(
    payload: T,
    indexScale: number = 1
): ChartDatum<T>[] {
    const d = payload.data;
    const keys = Object.keys(d) as Array<keyof typeof d>;

    const length = keys.reduce(
        (max, k) => Math.max(max, d[k]?.length ?? 0),
        0
    );

    return Array.from({ length }, (_, i) => {
        const point: any = { index: (i + 1) * indexScale };
        for (const k of keys) {
            point[k] = d[k][i] ?? null;
        }
        return point as ChartDatum<T>;
    });
};
